<style lang="css">

</style>

<template lang="html">

<list-template ref="list-template" actionUrl="carShow/user/findAssistanceUsers.action" :queryParams="searchInfo">
    <template slot="search">
      <el-input v-model="searchInfo.keyword" placeholder="电话、昵称、渠道来源" style="width:200px;"></el-input>
      <el-date-picker
        v-model="searchInfo.datetimerange"
        @change="onChange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <el-button type="primary" @click="$refs['list-template'].search()">搜索</el-button>
      <el-button type="primary" @click="exportExcel()">导出</el-button>
    </template>
    <template slot="item" scope="scope">
        <el-card v-for="data in scope.datas" class="basic-margin">
            <el-col :span="3">
              <img :src="data.userHead" style="width:120px;" alt="">
            </el-col>
            <el-col :span="21">
              <h4>{{data.nickname}}</h4>
            </el-col>
            <el-col :span="5">

                <p><span style="color:#999">注册时间</span> {{data.createTime | dateTimeFormat}}</p>
                <p><span style="color:#999">绑定手机</span> {{data.phone?data.phone:'未绑定'}}</p>
              <p><span style="color:#999">来源</span> <b>{{data.channelName?data.channelName:'未知'}}</b></p>
            </el-col>
            <el-col :span="11">
              <p><span style="color:#999">消耗车展币</span> <b>{{data.coinConsumeCount}}</b></p>
                <p><b>获得车展币</b> <span style="color:#999">{{data.coinCount}}</span> 个</p>
                <p style="color:#999">获得助力数 {{data.inviteCount}} 次</p>
            </el-col>
        </el-card>
    </template>
</list-template>

</template>

<script>
import ListTemplate from '@/components/ListTemplate'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
export default {
  name: 'car-exhibition-assistance-users',
  extends: BasicPager,
  components: {
    ListTemplate
  },
  data: function () {
    return {
      searchInfo: {
        keyword: null,
        carShowId: null,
        startTime: null,
        endTime: null,
        datetimerange: []
      }
    }
  },
  created: function () {
    let params = this.$route.params
    this.searchInfo.carShowId = params.carShowInfoId
  },
  activated: function () {
    let params = this.$route.params
    this.searchInfo.carShowId = params.carShowInfoId
    this.$refs['list-template'].loadList()
  },
  methods: {
    exportExcel: function () {
      let userInfo = this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      let url = Config.baseUrl + '/carShow/user/exportAssistanceUsersExcel.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath +
          '&carShowId=' + this.searchInfo.carShowId

      if (this.searchInfo.datetimerange && this.searchInfo.datetimerange[0]) {
        url += '&startTime=' + this.searchInfo.startTime + '&endTime=' + this.searchInfo.endTime
      }

      if (this.searchInfo.keyword) {
        url += '&keyword=' + this.searchInfo.keyword
      }

      window.open(url)
    },
    onChange: function (datetimerange) {
      if (!datetimerange || !datetimerange[0]) {
        this.searchInfo.startTime = null
        this.searchInfo.endTime = null
        this.$refs['list-template'].loadList()
        return
      }

      this.searchInfo.startTime = datetimerange[0].getTime()
      this.searchInfo.endTime = datetimerange[1].getTime()

      this.$refs['list-template'].search()
    }
  }
}

</script>
